export class SearchGeneralManagerModel {
    public name : string='';
    public pageSize : number = 10;
    public pageNumber : number=1;
}